<template>
  <v-col :cols="card_size" class="pa-1">
    <v-card>
      <v-card-title class="pa-6 pb-3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
          <div class="chartTitle text-truncate"
            v-bind="attrs"
            v-on="on">
            {{ title }}
          </div>
          </template>
          <span> {{ title  }} </span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <v-row no-gutters>
          <v-col cols="6" class="my-auto">
            <div v-if="state" :style="{ 'font-size': text_font_size, 'font-weight': text_font_weight }"> 
              {{ switchState }}
            </div>
            <div
              v-else
              :style="{ 'font-size': text_font_size, 'font-weight': 'bold' }"
              >{{ title_number }} 
              <span v-html="unitSymbol" /> 
            </div>
            <div v-if="subTitle != ''" class="mt-1">
              {{ subTitle }} 
              <span v-html="unitSymbol" /> 
            </div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-icon :color="card_icon_color" size="70">{{ card_icon }}</v-icon>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ApexChart from "vue-apexcharts";

@Component({
  components: { ApexChart },
})
export default class DeviceOverviewCard extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly title_number: string;
  @Prop({default: ''}) subTitle: string;
  @Prop() readonly card_icon: string;
  @Prop() readonly card_icon_color: string;
  @Prop() readonly text_font_size: string;
  @Prop({default: 'bold'}) readonly text_font_weight: string;
  @Prop({default: ''}) readonly unit: string;
  @Prop({default: false}) readonly state: boolean;
  @Prop({default: 3}) readonly card_size: string;

  get switchState() {
    return parseInt(this.title_number) ? 'ON' : 'OFF'
  }

  get unitSymbol() {
    switch (this.unit) {
      case 'celsius':
        return '&deg; C'
      case 'percentage':
        return '%'
      case 'bar':
        return 'bar'
      case 'pm':
        return '#/cm³'
      case 'mc_pm':
        return 'µg/m³'
      case 'ppm':
        return 'ppm'
      case 'kw':
        return 'kW'
      case 'kwh':
        return 'kWh'
      case 'watt':
        return 'W'
      case 'wmin':
        return 'Wmin'
      case 'voltage':
        return 'V'
      case 'euro':
        return '€'
      case 'usd':
        return '$'
      case 'kg':
        return 'kg'
      case 'lux':
        return 'lx'
      default:
        return ''
    }
  }
}



</script>

<style lang="scss">
@import "../../styles/app";

.chartTitle {
  padding: 0;
  position: relative;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000;
  font-size: 0.8em;
}
</style>
